import $ from "jquery";

jQuery(function ($) {
  const $footerWidgets = $(".site-footer .cell-menu .widget_nav_menu");

  if (!$footerWidgets.length) return;

  $footerWidgets.each(function () {
    const $widget = $(this);
    const $title = $widget.find("> span");
    const $menu = $widget.find("> div");

    if ($title.length && $menu.length) {
      $title.addClass("footer-accordion-btn");
      
      // Append modern feather-like Chevron Down SVG icon
      $title.append(
        '<span class="accordion-arrow">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
            '<polyline points="6 9 12 15 18 9"></polyline>' +
          '</svg>' +
        '</span>'
      );

      $title.on("click", function (e) {
        if (window.innerWidth >= 1024) return; // Only toggle on mobile (breakpoints < 1024px)
        
        e.preventDefault();
        const isOpen = $widget.hasClass("is-open");
        
        $widget.toggleClass("is-open", !isOpen);
        $menu.stop(true, true).slideToggle(250);
      });
    }
  });
});
